"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TagMerchantConfigurationEntity_1 = __importDefault(require("./Entity/TagMerchantConfigurationEntity"));
var TagMerchantConfiguration = /** @class */ (function () {
    function TagMerchantConfiguration(session) {
        this.tagMerchantConfiguration = new TagMerchantConfigurationEntity_1.default(session);
    }
    TagMerchantConfiguration.prototype.getAll = function () {
        return this.tagMerchantConfiguration.service.getAll();
    };
    TagMerchantConfiguration.prototype.getByTag = function (tagId) {
        return this.tagMerchantConfiguration.getByTag(tagId);
    };
    TagMerchantConfiguration.prototype.create = function (tagId, tagMerchantConfiguration) {
        return this.tagMerchantConfiguration.service.create(__assign(__assign({}, tagMerchantConfiguration), { tag_id: tagId }));
    };
    TagMerchantConfiguration.prototype.update = function (id, tagMerchantConfiguration) {
        return this.tagMerchantConfiguration.service.update(id, tagMerchantConfiguration);
    };
    TagMerchantConfiguration.prototype.delete = function (id) {
        return this.tagMerchantConfiguration.service.delete(id);
    };
    return TagMerchantConfiguration;
}());
exports.default = TagMerchantConfiguration;
//# sourceMappingURL=TagMerchantConfiguration.js.map